import { render, staticRenderFns } from "./intelligentBodyRecord.vue?vue&type=template&id=238dfa7c&scoped=true"
import script from "./intelligentBodyRecord.vue?vue&type=script&lang=js"
export * from "./intelligentBodyRecord.vue?vue&type=script&lang=js"
import style0 from "./intelligentBodyRecord.vue?vue&type=style&index=0&id=238dfa7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238dfa7c",
  null
  
)

export default component.exports